const assertProcessEnv = require('assert-process-env');

export const IS_CLIENT_SIDE = typeof window !== 'undefined';
export const DEBUG = process.env.NODE_ENV !== 'production';

export const LAUNCHDARKLY_SDK_KEY: string = assertServerSideRuntimeEnv(
	'LAUNCHDARKLY_SDK_KEY',
);
export const JWT_SECRET_KEY: string =
	assertServerSideRuntimeEnv('JWT_SECRET_KEY');

function assertServerSideRuntimeEnv(name: string) {
	return assertProcessEnv(name, (value: string | undefined) => {
		if (!process.env.IS_SERVER_RUNTIME || IS_CLIENT_SIDE) return true;
		return !!value;
	});
}
